export default __webpack_public_path__ + "static/media/chat_outline.38692b36.svg";